import { MethodTypeRepository } from '@telespot/domain';

export interface SaveAssignedPipelinesInput {
  methodTypeId: string;
  /**
   * The FULL final assigned set. SET semantics: `ProtocolPipeline` joins of
   * pipelines absent from it are destroyed (un-assignments), missing ones are
   * created — one use case covers both directions of the diff.
   */
  pipelineIds: string[];
}

export enum SaveAssignedPipelinesErrorCode {
  MISSING_METHOD_TYPE_ID = 'A `methodTypeId` is required to save the assigned pipelines.',
}

export class SaveAssignedPipelinesException extends Error {
  constructor(public readonly code: SaveAssignedPipelinesErrorCode) {
    super(code.toString());
    this.name = 'SaveAssignedPipelinesException';
    Object.setPrototypeOf(this, SaveAssignedPipelinesException.prototype);
  }
}

export interface ISaveAssignedPipelinesCommand {
  execute(input: SaveAssignedPipelinesInput): Promise<void>;
}

export class SaveAssignedPipelinesCommand implements ISaveAssignedPipelinesCommand {
  constructor(private readonly methodTypeRepository: MethodTypeRepository) {}

  public async execute(input: SaveAssignedPipelinesInput): Promise<void> {
    if (!input.methodTypeId) {
      throw new SaveAssignedPipelinesException(SaveAssignedPipelinesErrorCode.MISSING_METHOD_TYPE_ID);
    }

    await this.methodTypeRepository.savePipelinesAssigned(input.methodTypeId, [...new Set(input.pipelineIds)]);
  }
}
